import { FormationDetailProps } from '@/types/formation';

export const aiprFormation: FormationDetailProps = {
  id: '28',
  title: 'Formation AIPR - Autorisation d\'Intervention à Proximité des Réseaux',
  description: 'Formation obligatoire pour toute personne réalisant des travaux à proximité des réseaux, conformément à l\'arrêté du 15 février 2012.',
  duration: '2 jours (14 heures)',
  category: 'Travaux publics',
  imageSrc: '/images/home/sdpsilogo.png',
  slug: 'sdpsi',
  reference: 'F-AIPR',
  price: 'Sur devis – nous contacter',
  targetAudience: 'Chefs de chantier, conducteurs de travaux, opérateurs de travaux, responsables d\'entreprise du BTP',
  prerequisites: 'Aucun prérequis particulier',
  objectives: [
    'Connaître la réglementation relative à la prévention des risques liés aux travaux à proximité des réseaux',
    'Savoir lire et interpréter les documents techniques',
    'Maîtriser les procédures avant, pendant et après les travaux',
    'Connaître les bonnes pratiques de prévention des dommages aux réseaux',
    'Savoir réagir en cas d\'accident ou d\'incident'
  ],
  program: [
    {
      title: 'Cadre réglementaire',
      items: [
        'Les textes applicables (code de l\'environnement, code du travail, etc.)',
        'Les responsabilités des différents acteurs',
        'Les obligations légales et réglementaires',
        'Les sanctions encourues en cas de non-respect des règles'
      ]
    },
    {
      title: 'Techniques de détection et de repérage',
      items: [
        'Les différents types de réseaux et leurs spécificités',
        'Les techniques de détection et de localisation',
        'La lecture des plans et documents techniques',
        'L\'utilisation des appareils de détection'
      ]
    },
    {
      title: 'Organisation des travaux',
      items: [
        'Le processus d\'élaboration d\'un projet',
        'La préparation du chantier',
        'Les différentes phases d\'intervention',
        'La coordination des différents intervenants'
      ]
    },
    {
      title: 'Sécurité et prévention',
      items: [
        'Les risques liés aux différents types de réseaux',
        'Les mesures de prévention à mettre en œuvre',
        'Les équipements de protection individuelle et collective',
        'La conduite à tenir en cas d\'accident ou d\'incident'
      ]
    }
  ],
  pedagogicalMethods: [
    'Apports théoriques',
    'Études de cas concrets',
    'Exercices pratiques',
    'Échanges avec les participants',
    'Support de formation remis à chaque participant'
  ],
  evaluationMethods: [
    'Évaluation des connaissances acquises',
    'Mise en situation pratique',
    'Questionnaire de validation des acquis'
  ],
  certification: 'Attestation de formation AIPR',
  registrationProcess: [
    'Inscription possible jusqu\'à 15 jours avant le début de la formation',
    'Groupe de 4 à 10 participants maximum'
  ],
  accessibilityCriteria: 'Formation accessible aux personnes en situation de handicap. Nous contacter pour adapter la formation selon les besoins spécifiques.',
  formatterInfo: {
    name: 'Sébastien DAVRAINVILLE - SDPSI Formation',
    phone: '06.22.61.04.09',
    email: 'sdpsiformation@orange.fr',
    website: 'www.sdpsi-formations.fr'
  }
};
